import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledCategoryPills = styled.nav`
	max-width: 1200px;
	margin: 30px auto 0;
	padding: 0 20px;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		margin: 40px auto 0;
		padding: 0 40px;
	}

	.pills-track {
		display: flex;
		flex-wrap: nowrap;
		gap: 8px;
		overflow-x: auto;
		padding: 4px 0;
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			flex-wrap: wrap;
			justify-content: center;
			overflow-x: visible;
		}
	}

	.pill {
		flex-shrink: 0;
		padding: 7px 16px;
		border-radius: 999px;
		font-family: ${CSSVars.primaryFont};
		font-size: ${CSSVars.fontSizeSM};
		font-weight: 500;
		color: ${CSSVars.gray500};
		background: transparent;
		border: 1px solid ${CSSVars.gray100};
		text-decoration: none;
		transition: 0.2s;
		white-space: nowrap;

		&:hover {
			border-color: ${CSSVars.blue500};
			color: ${CSSVars.blue500};
		}

		&.active {
			background: ${CSSVars.black};
			color: ${CSSVars.white};
			border-color: ${CSSVars.black};

			&:hover {
				color: ${CSSVars.white};
				border-color: ${CSSVars.black};
			}
		}

		&.more {
			color: ${CSSVars.blue500};
			border-style: dashed;
		}
	}
`;
